import { useEffect } from 'react'
import Container from '@mui/material/Container'
import { useTranslation } from 'react-i18next'
import HelmetMeta from '../../layouts/HelmetMeta.js'

export default function Privacy () {
  const { t } = useTranslation('legals')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <HelmetMeta
        {...{
        title: t('privacy.metaTitle'),
        description: t('privacy.metaDescription'),
        image: '/img/races/i/ramadan-race.jpg'
      }}
      />
      <div>
        <br /><br /><br /><br />
        <h1>{t('privacy.heading')}</h1>
        <p>
          {t('privacy.p1Before')}
          <a style={{ color: 'orange' }} href='https://www.peakssports.com'>peakssports.com</a>
          {t('privacy.p1After')}
        </p>
        <h2>{t('privacy.s1Heading')}</h2>
        <h3>{t('privacy.logDataHeading')}</h3>
        <p>{t('privacy.logDataP')}</p>
        <h3>{t('privacy.deviceDataHeading')}</h3>
        <p>{t('privacy.deviceDataP')}</p>
        <h3>{t('privacy.personalInfoHeading')}</h3>
        <p>{t('privacy.personalInfoP')}</p>
        <ul>
          <li>{t('privacy.personalInfoLi1')}</li>
          <li>{t('privacy.personalInfoLi2')}</li>
          <li>{t('privacy.personalInfoLi3')}</li>
          <li>{t('privacy.personalInfoLi4')}</li>
          <li>{t('privacy.personalInfoLi5')}</li>
          <li>{t('privacy.personalInfoLi6')}</li>
          <li>{t('privacy.personalInfoLi7')}</li>
          <li>{t('privacy.personalInfoLi8')}</li>
        </ul>
        <h2>{t('privacy.s2Heading')}</h2>
        <p>{t('privacy.s2p1')}</p>
        <p>{t('privacy.s2p2')}</p>
        <ul>
          <li>{t('privacy.s2li1')}</li>
          <li>{t('privacy.s2li2')}</li>
          <li>{t('privacy.s2li3')}</li>
          <li>{t('privacy.s2li4')}</li>
        </ul>
        <p>{t('privacy.s2p3')}</p>
        <p>{t('privacy.s2p4')}</p>
        <h2>{t('privacy.s3Heading')}</h2>
        <p>{t('privacy.s3p1')}</p>
        <ul>
          <li>{t('privacy.s3li1')}</li>
          <li>{t('privacy.s3li2')}</li>
          <li>{t('privacy.s3li3')}</li>
          <li>{t('privacy.s3li4')}</li>
          <li>{t('privacy.s3li5')}</li>
          <li>{t('privacy.s3li6')}</li>
          <li>{t('privacy.s3li7')}</li>
          <li>{t('privacy.s3li8')}</li>
          <li>{t('privacy.s3li9')}</li>
        </ul>
        <h2>{t('privacy.s4Heading')}</h2>
        <p>{t('privacy.s4p1')}</p>
        <ul>
          <li>{t('privacy.s4li1')}</li>
          <li>{t('privacy.s4li2')}</li>
          <li>{t('privacy.s4li3')}</li>
          <li>{t('privacy.s4li4')}</li>
          <li>{t('privacy.s4li5')}</li>
          <li>{t('privacy.s4li6')}</li>
          <li>{t('privacy.s4li7')}</li>
        </ul>
        <h2>{t('privacy.s5Heading')}</h2>
        <p>{t('privacy.s5p1')}</p>
        <p>{t('privacy.s5p2')}</p>
        <p>{t('privacy.s5p3')}</p>
        <h2>{t('privacy.s6Heading')}</h2>
        <p><strong>{t('privacy.s6ChoiceLabel')}</strong>{' '}{t('privacy.s6ChoiceText')}</p>
        <p><strong>{t('privacy.s6ThirdPartyLabel')}</strong>{' '}{t('privacy.s6ThirdPartyText')}</p>
        <p><strong>{t('privacy.s6RestrictLabel')}</strong>{' '}{t('privacy.s6RestrictText')}</p>
        <p><strong>{t('privacy.s6AccessLabel')}</strong>{' '}{t('privacy.s6AccessText')}</p>
        <p><strong>{t('privacy.s6CorrectionLabel')}</strong>{' '}{t('privacy.s6CorrectionText')}</p>
        <p><strong>{t('privacy.s6BreachLabel')}</strong>{' '}{t('privacy.s6BreachText')}</p>
        <p><strong>{t('privacy.s6ComplaintsLabel')}</strong>{' '}{t('privacy.s6ComplaintsText')}</p>
        <p><strong>{t('privacy.s6UnsubscribeLabel')}</strong>{' '}{t('privacy.s6UnsubscribeText')}</p>
        <h2>{t('privacy.s7Heading')}</h2>
        <p>{t('privacy.s7p1')}</p>
        <h2>{t('privacy.s8Heading')}</h2>
        <p>{t('privacy.s8p1')}</p>
        <h2>{t('privacy.s9Heading')}</h2>
        <p>{t('privacy.s9p1')}</p>
        <h2>{t('privacy.s10Heading')}</h2>
        <p>{t('privacy.s10p1')}</p>
        <p>{t('privacy.s10p2')}</p>
        <p>
          <strong>{t('privacy.controllerLabel')}</strong>
          <br />
          {' '}{t('privacy.controllerName')}
          <br />
          {' '}{t('privacy.controllerPhone')}
        </p>
        <p>
          <strong>{t('privacy.officerLabel')}</strong>
          <br />
          {' '}{t('privacy.officerName')}
          <br />
          {' '}{t('privacy.officerPhone')}
        </p>
        <p>{t('privacy.effectiveDate')}</p>
      </div>
    </Container>
  )
}
